import baseConfig from "../config.js";
import basicFormHelper from "../basic.form.helper.js";
import {regular} from "../validate.js.js";

//注明：如果列表中需要有编码，配置initCodeRules，则会自动加载XXDesc,XXCodeItems(XX表示数据项的属性名)
const columns:any = [
	{
		dataIndex: 'number',
		title: '序号',
		scopedSlots: { customRender: 'num' },
	},
	{
		dataIndex: 'address',
		title: '教室地址',
	},
	{
		dataIndex: 'name',
		title: '教室号',
	},
	{
		dataIndex: 'typeDesc',
		title: '教室类型',
	},
	{
		dataIndex: 'totalSeat',
		title: '座位数',
	},
	{
	  title: '操作',
	  dataIndex: 'operation',
	  scopedSlots: { customRender: 'operation' },
	}
];


const form:any = {
	_id: "",
	address:"",
	name:"",
	schoolId:"",
	type:undefined,
	totalSeat:""
};

const formRules:any = {
    address: [{
            required: true,
            message: "请输入教室地址",
            trigger: "blur"
        },
        { min: 1, max: 50, message: '最大长度50', trigger: 'blur'},
    ],
    name:[{
        required: true,
        message: "请输入教室号",
        trigger: "blur"
        },
        { min: 1, max: 50, message: '最大长度50', trigger: 'blur'},
    ],
    type:[{
        required: true,
        message: "请输入教室类型",
        trigger: "blur"
        },
        { min: 1, max: 50, message: '最大长度50', trigger: 'blur'},
    ],
    totalSeat:[{
        required: true,
        message: "请输入座位数",
        trigger: "blur"
    }]
};
// {type: 'string', validator: validateOrder, trigger: 'blur'}
const checkData =function(rule:any, value:any, callback:any) {
    if (value) {
        if (!/^1[3|4|5|7|8|9][0-9]\d{8}$/.test(value)) {
            callback(new Error('请输入正确的手机号!'))
        } else {
            callback()
        }
    }
    callback()
};
const checkSpecial =function(rule:any, value:any, callback:any) {
    if (value) {
        if (!/^[\u4E00-\u9FA5A-Za-z0-9]+$/g.test(value)) {
            callback(new Error('请勿输入特殊符号!'))
        } else {
            callback()
        }
    }
    callback()
};

/**
 * 把本地页面data中定义的form转换接口所需的数据格式
 * @param {Object} pageForm
 */
const convertDbForm = function(pageForm:any) {
	let dbForm = {
		...{},
		...pageForm
	};
	return dbForm;
};

/**
 * 把通过查询返回的数据格式塞入到页面data的from属性中
 * @param {Object} dbFrom
 * @param {Object} contextForm
 */
const dbToForm = function(dbFrom:any, contextForm:any) {
	//赋值
	let newForm:any = {};

	for (let p in dbFrom) {
		newForm[p] = dbFrom[p];
	}
	return newForm;
};

export default {
	columns,
	form,
	copyNewForm: basicFormHelper.copyNewForm,

	formRules,
	convertDbForm,
	dbToForm,

	allowUploadTypes: basicFormHelper.allowUploadTypes
}
